const containers = [...document.querySelectorAll('section.profile .container[data-expand]')]; 

const expand = container => e => {
	e.preventDefault();
	let value = (container.dataset.expand == 1) ?  0 : 1;
	let text = (value == 1) ? 'sluiten' : 'aanpassen';
	container.dataset.expand = value;
	e.currentTarget.innerText = text;
	if(value == 1)
		container.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
}

const setListener = container => {
	let trigger = container.querySelector('.title a'); 
	let setExpandState = expand(container); 
	trigger.addEventListener('click',setExpandState);
}

export default () => {
	if(containers)
	{
		containers.forEach(setListener); 
	}
}